<template>
  <div class="group-relationship-approved">
    <a-card style="margin:10px 0;">
      <SearchView
        :renderItem="searchSchema"
        :initialValues="searchData"
        formLayout="inline"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>
    <a-card style="margin:10px 0;">
      <TableView
        :data="tableData"
        :loading="tableLoading"
        :pagination="pageData"
        :columns="columns"
        @handlePagination="handleClickPage"
        :scroll="{ x: 2600 }"
      >
        <template v-slot:bpmId="{ tableRow }">
          <span class="name" @click="handleView(tableRow)">
            {{ tableRow.bpmId }}
          </span>
        </template>
        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            审核
          </a-button>
        </template>
      </TableView>
    </a-card>
  </div>
</template>

<script>
import { getTableData } from './api'
import { TableView, SearchView } from 'lxfintech-fe'
import mixin from './mixin'
import moment from 'moment'
export default {
  data() {
    //这里存放数据
    return {
      tableLoading: false,
      tableData: [],
      moment,
    }
  },
  mixins: [mixin],
  components: {
    TableView,
    SearchView,
  },

  //方法集合
  methods: {
    // 获取表格数据
    async _getTableData() {
      this.tableLoading = true
      try {
        const { current, pageSize } = this.pageData
        const query = {
          ...this.searchData,
          size: pageSize,
          current,
        }
        const {
          data: { total, records },
        } = await getTableData(query)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.log(error)
      }
    },
    // 查询
    handleSearch(query) {
      this.searchData = { ...this.searchData, ...query }
      this.pageData.current = 1
      this._getTableData()
    },
    // 分页
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
    handleView(data) {
      this.$router.push({
        path: `/customer-credit/approved-approval/${data.bpmId}`,
        query: {
          companyCode: data.childCode,
          status: 1,
        },
      })
    },
  },

  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getTableData()
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.name {
  color: #409eff;
  cursor: pointer;
}
</style>
